document.addEventListener("turbo:load", () => {
  document.querySelectorAll("input[data-sync-radio-buttons=true]").forEach((element) => {
    element.addEventListener("change", (event) => {
      const value = event.target.dataset.syncRadioButtonsValue;
      const radio = document.querySelector(`input[data-sync-radio-buttons-value-target=${value}]`);
      radio.checked = true;
      radio.dispatchEvent(new Event("change"));
    });
  });
});
